import { useMemo } from 'react'

import { Form } from 'factorial-form'
import constant from 'lodash/constant'
import times from 'lodash/times'
import zipObject from 'lodash/zipObject'

/**
 * Create a form for all the categories, setting their type to boolean
 * and default value to false
 */
interface Props {
  categories: Record<string, string>
}

const useForm = ({ categories }: Props): Form => {
  const form = useMemo<Form>(() => {
    const keys = Object.keys(categories)

    return new Form(
      zipObject(keys, times(keys.length, constant(false))),
      zipObject(keys, times(keys.length, constant('boolean')))
    )
  }, [categories])

  return form
}

export default useForm
